var exports = {
  "CT": "DiscoverySkeleton.module__navList___U2l0cG",
  "pc": "DiscoverySkeleton.module__navItem___U2l0cG",
  "HW": "DiscoverySkeleton.module__navItemActive___U2l0cG",
  "hk": "DiscoverySkeleton.module__navItemLabel___U2l0cG",
  "kL": "DiscoverySkeleton.module__container___U2l0cG",
  "v_": "DiscoverySkeleton.module__navbar___U2l0cG",
  "$L": "DiscoverySkeleton.module__categoryTabs___U2l0cG",
  "VJ": "DiscoverySkeleton.module__navbarSearch___U2l0cG",
  "Gm": "DiscoverySkeleton.module__scrollBody___U2l0cG",
  "Qs": "DiscoverySkeleton.module__content___U2l0cG",
  "Vg": "DiscoverySkeleton.module__grid___U2l0cG",
  "Nr": "DiscoverySkeleton.module__card___U2l0cG",
  "zl": "DiscoverySkeleton.module__cardBanner___U2l0cG",
  "Ie": "DiscoverySkeleton.module__cardIcon___U2l0cG",
  "zI": "DiscoverySkeleton.module__cardBody___U2l0cG",
  "JJ": "DiscoverySkeleton.module__cardTitle___U2l0cG",
  "L_": "DiscoverySkeleton.module__cardDescription___U2l0cG",
  "UX": "DiscoverySkeleton.module__cardFooter___U2l0cG",
  "Kd": "DiscoverySkeleton.module__cardStats___U2l0cG",
  "Ne": "DiscoverySkeleton.module__cardStat___U2l0cG",
};

module.exports = exports;
